/* eslint-disable max-len */

import React from 'react';

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 19.9185V3.98833C21 3.44242 20.5551 3 20.0066 3H3.99343C3.44468 3 3 3.44242 3 3.98833V19.9185C3 20.4642 3.44468 20.9067 3.99343 20.9067H20.0066C20.5551 20.9067 21 20.4642 21 19.9185Z" fill="#4267B2" />
    <path d="M15.7223 20.9999V14.2816H18.0465L18.3945 11.5695H15.7223V9.83796C15.7223 9.05273 15.9392 8.5176 17.0596 8.5176L18.4886 8.51692V6.09124C18.2414 6.05825 17.3932 5.98438 16.4063 5.98438C14.346 5.98438 12.9356 7.24826 12.9356 9.56941V11.5695H10.6055V14.2816H12.9356V20.9999H15.7223Z" fill="white" />
  </svg>

);
